/* Copyright (c) 2017 Backpack Health LLC */

import { connect } from 'react-redux';

import RouteNames from '../../../RouteNames';
import * as selectors from '../../../redux/reduxSelectors';

import NavigationActions from '../../../redux/NavigationActions';
import { selectors as groupSelectors } from '../../../../redux/ducks/group';
import { actions as groupActions } from '../../../../redux/ducks/group';

import MyGroups from './MyGroups';

function mapStateToProps(state, routerProps) {
  const history = routerProps.history;
  const profileId = selectors.getActiveProfileId(state);
  const profile = selectors.getActiveProfile(state);

  return {
    profile,
    profileId,
    isMainProfile: profileId === selectors.getMainProfileId(state),
    activeGroupIds: groupSelectors.getActiveGroupIdsForProfile(state, profileId),
    inactiveGroupIds: groupSelectors.getInactiveGroupIdsForProfile(state, profileId),
    onSelectGroup: (groupId) => {
      NavigationActions.goTo(history, RouteNames.groupInfo(groupId));
    },
    onGoToFindGroup: () => {
      NavigationActions.goTo(history, RouteNames.findGroup());
    },
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadData: (profileId) => {
      dispatch(groupActions.requestGroups(profileId));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MyGroups);
